import React from 'react'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { useTranslation } from 'react-i18next'
import bumeranMasTelefonicaSVG from '../../assets/images/landings/bumeranMasTelefonica.svg'
import {
  BannerContainer,
  Description,
  IconCustom,
  ImgContainer,
  ImgCustom,
  TextContainer,
  Title,
  TitleContainer,
  Stripes,
} from './mixins'
import { SITE_ID } from '../../constants'

const TELEFONICA_URL =
  'https://mapadelempleo.fundaciontelefonica.com/arg?_ga=2.225395162.1382093837.1642787986-1271303123.1639425988'

const BannerFundacionTelefonica = () => {
  const { t } = useTranslation()
  const { isTabletLandscape, isDesktop } = useWindowSize()
  const isDesktopOrTabletLandscape = isTabletLandscape || isDesktop
  const isArgentina = SITE_ID === 'BMAR'

  if (!isArgentina) {
    return null
  }

  return (
    <BannerContainer href={TELEFONICA_URL} rel="nofollow" target="_blank">
      <TextContainer>
        <TitleContainer>
          <Title>
            Consultá el <strong>Mapa del Empleo</strong>
          </Title>
          {!isDesktopOrTabletLandscape && <Icon name="icon-light-caret-right" color="#000018D6" size="24" />}
        </TitleContainer>
        <Description>{t('landingJovenesProfesionales.bannerTelefonica')}</Description>
      </TextContainer>

      {isDesktopOrTabletLandscape && <IconCustom name="icon-light-caret-right" color="#000018D6" size="32" />}

      <ImgContainer>
        <ImgCustom alt="Banner Telefonica" src={bumeranMasTelefonicaSVG} />
        <Stripes />
      </ImgContainer>
    </BannerContainer>
  )
}

export default BannerFundacionTelefonica
